// src/api/axiosAuth.js
import axios from 'axios';
import useAuthStore from '../store/useAuthStore';

const BASE_URL = 'https://nfcadmin.mhcockpit.com/api';

const axiosAuth = axios.create({
    baseURL: BASE_URL,
});

// Custom token getter using Zustand
const getToken = () => {
    // Direct access to Zustand store outside of a React component
    const {
        accessToken
    } = useAuthStore.getState();
    return accessToken;
};

axiosAuth.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default axiosAuth;